// extracted by mini-css-extract-plugin
module.exports = {"rootinner":"message_rootinner_19GlP","bg":"message_bg_36ob0","text":"message_text_2Zlk-","btn":"message_btn_Msphk"};